import * as React from 'react';
import {FunctionComponent, useState} from 'react';
import {ExpandedPart} from '../../../../business/expanded_parts/ExpandedPartsProvider';
import {Chapter} from '../../../../models/Chapter';
import Modal from '../../../../../../components/modal';
import {v4} from 'uuid';

interface OwnProps {
    expandedPart: ExpandedPart;
    onAdd: (chapter: Chapter) => void;
    onCancel: () => void;
}

export const AddChapterWizard: FunctionComponent<OwnProps> = ({expandedPart, onAdd, onCancel}) => {
    const [value, setValue] = useState('');
    return (
        <Modal visible={true} onHide={onCancel}>
            <div className="modal-header">
                <h2>Add chapter</h2>
            </div>
            <div className="modal-body">
                <form>
                    <div className="form-group">
                        <label htmlFor="instruction">Title</label>
                        <input
                            id="instruction"
                            type="text"
                            name="instruction"
                            className="form-control"
                            value={value || ''}
                            onChange={(e) => setValue(e.target.value)}
                        />
                    </div>
                </form>
            </div>
            <div className="modal-footer">
                <button
                    className="btn btn-secondary pull-right"
                    onClick={() =>
                        onAdd({
                            __uuid: v4(),
                            __expandedPartUuid: expandedPart.__uuid,
                            title: value,
                            thumbnail_id: null, //TODO
                            thumbnail_url: null, //TODO
                        })
                    }
                >
                    Insert
                </button>
                <button className="btn btn-secondary pull-right" onClick={onCancel}>
                    Cancel
                </button>
            </div>
        </Modal>
    );
};
